import { Component, Input } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'confirm-limit-assign-component',
  templateUrl: './confirm-limit-assign.component.html',
  styleUrls: ['./confirm-limit-assign.component.scss'],
})
export class ConfirmLimitAssignComponent {
  @Input() public data: any;
  public modalText: string;

  constructor(
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {}

  ngOnChanges($event: any) {
    let modalText: string = this.dictionaryService.get('CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_1') + ' ';
    switch (this.data.type) {
      case 'supply':
        modalText += this.dictionaryService.get('SUPPLY').toLowerCase() + ' ';
        break;
      case 'demand':
        modalText += this.dictionaryService.get('DEMAND').toLowerCase() + ' ';
        break;
    }
    modalText += this.dictionaryService.get('CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_2') + ' ';
    modalText += this.data.amount + ' ';
    modalText += this.dictionaryService.get('CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_3') + ' ';
    switch (this.data.type) {
      case 'supply':
        modalText += this.dictionaryService.get('DEMANDS') + '.<br/>';
        break;
      case 'demand':
        modalText += this.dictionaryService.get('SUPPLIES') + '.<br/>';
        break;
    }
    modalText += this.dictionaryService.get('CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_4') + ' ';
    switch (this.data.type) {
      case 'supply':
        modalText += this.dictionaryService.get('DEMANDS') + '.';
        break;
      case 'demand':
        modalText += this.dictionaryService.get('SUPPLIES') + '.';
        break;
    }
    this.modalText = modalText;
  }

  confirm() {
    this.sharedService.sendMessage('CONFIRM_LIMIT_ASSIGN');
    this.modalsService.hideModal('confirm');
  }
}
